/**
 * @file  paymentPlan/paymentPlan.model.ts
 * @description  payment plan information
 *
 * @author ogarcia (ozkary)
 *
 */
import { Surcharge } from '../quotes/quotes.model';

/**
 * the possible payment types
 */
export enum PaymentType {
  Down = 'down',
  Full = 'full'
}

/**
 * defines the payment information
 */
export default interface Payment {
  amount: number;
  tax: number;
  payments: number;
  zip?: string;
  rate: number;
  fees?: number;
  state?: string;
  startDate?: string;
  paymentType?: PaymentType;
  nextPaymentDate?: string;
  otherAmount?: number; // discount or surcharges
  docFeeRate?: number;
  docFeeMultiple?: number;
  payNow?: number;
  options?: Surcharge[];
  // downpayment %  server-settings
  // terms (18) server-settings
} // eslint-disable-line

/**
 * defines the payment plan information with taxes and fees
 */
export interface Plan extends Payment {
  id: string;
  down: number;
  installments: number;
  monthlyAmount: number;
  total: number;
  status?: number;
  totalWithTaxes?: number;
  downWithTaxes?: number;
  monthlyTax: number;
  monthlyWithFeesTaxes?: number;
  docFee?: number;
  downRate?: number;
  downTaxAmount?: number;
  totalDiscounts?: number;
  hiddenAdjustments?: number;
  financeAmount? : number;
  retailDown?: number;
  retailMonthly?: number;
  totalOptions?: number;
  estDown?: number;
  estMonthly?: number;
  amountWithOptions: number;
  downWithOptions: number;
  updated?: string;
  timestamp?: number;
  defaultPayTerm?: number;
}

/**
 * financial payment plan which is used when submitting a contract
 */
export interface FinancialPlan {
  startDate?: string;
  amount: number;
  down?: number;
  downRate?: number;
  fees?: number;
  docFee?: number;
  payments: number;
  action: string;
}
